@import "src/helpers/ScreenSizes.scss"; //mixins for different screen sizes

:host {
  box-sizing: border-box;
  display: block;
  width: 100%;
}

.infoMessage {
  //TODO margin below is a workaround and need to be fixed during https: //payair.atlassian.net/browse/SRC-765
  margin: 0 0 0 0;
  border-radius: 8px;
}

.error {
  background: #ef2039;
}

.alert {
  background: #f79e1b;
}

.infoMessageContent {
  padding: 18px;
  @include small() {
    padding: 13px;
  }
  display: flex;
  align-items: center;
}

.infoMessageText {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;
  margin: 0 16px 0 16px;

  @include small() {
    font-size: 14px;
  }
}

.infoMessageText.clickable {
  margin: 0 16px 0 0px;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}
